import React from 'react'
import PropTypes from 'prop-types'
import { GatsbyImage as Img } from 'gatsby-plugin-image'
import { css } from 'theme-ui'
import Divider from '@components/Divider'
import getImageVariant from '@components/utils/getImageVariant'
import { ImageZoom } from '@qiyo_components/ImageZoom'

const styles = {
  regular: {
    minHeight: `23rem`,
    img: {
      borderRadius: `lg`
    }
  },
  wide: {
    img: {
      borderRadius: `lg`
    }
  },
  inCard: {
    mt: -4,
    mx: -4,
    img: {
      borderRadius: t => `${t.radii.lg} ${t.radii.lg} 0 0`
    }
  },
  inCardLarge: {
    mt: [-4, -5],
    mx: [-4, -5],
    img: {
      borderRadius: t => `${t.radii.lg} ${t.radii.lg} 0 0`
    }
  }
}

// Michael Lu, 2024/10/19
export const PostImage2 = ({
  title,
  preview,
  thumbnail,
  wide,
  full,
  inCard,
  inCardLarge
}) => {
  if (!(preview || thumbnail)) return null

  // console.log('preview=', preview)
  // console.log('thumbnail=', thumbnail)

  const variant = (wide && 'wide') || (full && 'full') || 'regular'
  if (preview) {
    return (
      <>
        <div
          css={css({
            ...styles[variant],
            ...(inCard && styles.inCard),
            ...(inCardLarge && styles.inCardLarge)
          })}
        >
          <ImageZoom
            src={preview}
            alt={title}
            width='100%'
            style={
              variant === 'wide' || variant === 'full' ? styles.full : undefined
            }
          ></ImageZoom>
        </div>
        <Divider space={3} />
      </>
    )
  } else {
    const image = getImageVariant(preview || thumbnail, 'hero')
    return (
      <>
        <Img
          image={image}
          alt={title}
          css={css({
            ...styles[variant],
            ...(inCard && styles.inCard),
            ...(inCardLarge && styles.inCardLarge)
          })}
          imgStyle={
            variant === 'wide' || variant === 'full' ? styles.full : undefined
          }
        />
        <Divider space={3} />
      </>
    )
  }
}

PostImage2.propTypes = {
  wide: PropTypes.bool,
  full: PropTypes.bool,
  inCard: PropTypes.bool,
  inCardLarge: PropTypes.bool
}

// 7 種在 React 引入圖片的方法。為什麼 img 的 src 無效?!
// https://molly1024.medium.com/7-%E7%A8%AE%E5%9C%A8-react-%E5%BC%95%E5%85%A5%E5%9C%96%E7%89%87%E7%9A%84%E6%96%B9%E6%B3%95-%E7%82%BA%E4%BB%80%E9%BA%BC-img-%E7%9A%84-src-%E7%84%A1%E6%95%88-41a65965c468
// https://ithelp.ithome.com.tw/articles/10226711